<template>
	<div class="Gheader2" :style="gunshang">
		<div class="Gheader_login " style="background: #fff;">
			<div class="flex j-end mr-74" @click="$dakai('/user-Profile')" v-if="kouling && kouling.length > 0">
				<div class="iconfont icon-renwu-ren" style="font-size: .2rem !important;line-height: .54rem;"></div>
				<div class="montserLight" style="color: #333;line-height: .54rem;">{{ $qu('yonghuming') }}</div>
			</div>
			<div v-else class="Gheader_login_item flex j-end" @click="$dakai('/login_in')">
				<span style="line-height: .54rem;">
					<!-- Log in with -->
					{{gudingziduan.shouye.toubu.loginsems}}
					</span>
				<span class="iconfont icon-Frame ml-5 montserLight" style="line-height: .54rem;"></span>
			</div>
		</div>
		<div class="Gheader2_menu flex">
			<el-image @click="Shouye"
				:src="require('@/assets/pc/logo/logo.png')"
				class="logo" :class="menuindex == 1 ? 'guanbilogo' : ''"></el-image>
			<div class="Gheader2_right_menu flex cur_pointer">
				<template v-if="plusRegion!='eu'">
					<div  v-for="(l, i) in gudingziduan.shouye.toubu.list" :class="Tindexx == i ? 'zihong' : ''" class="item t-center tit-18 montserRegular"
						@click="tiaoz(l, i)">
						{{ l.name }}</div>
				</template>
				<template v-else-if="plusRegion=='eu'">
					<div v-for="(l, i) in gudingziduan.shouye.toubu.list4" :class="Tindexx == i ? 'zihong' : ''" class="item t-center tit-18 montserRegular"
						@click="tiaoz(l, i)">
						{{ l.name }}</div>
				</template>
			</div>
			<div class="Gheader2_right_soubox flex">
				<div class="pl-20 pr-20 Gheader2_right_soubox_item" style="position: relative;" @click="xuanyan">
					<!-- 语言下拉 -->
					<el-dropdown placement="bottom" style="margin: 0;" @command="yuyandian">
						<div class="el-dropdown-link tit-16 montserRegular cur_pointer" style="color: #333; margin: 0;">
							<span class="iconfont icon-earth tit-16"></span>
							<span >{{yuyancode}}</span>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="l in yuyanlist" :command="l.k">{{ l.name }}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<!-- 语言下拉 end!!-->
				</div>
				<div class="xiant2 rel pl-20 pr-20 Gheader2_right_soubox_item montserRegular cur_pointer" @click="shousousuo">
					<span class="iconfont icon-sousuo1"></span>
				</div>
				<div class="Gheader2_right_soubox_item">
					<div class="Gheader2_right_bofan cur_pointer" @click="bofan">
					</div>
				</div>
			</div>
			<div class="iconfont  mini_right_menu" :class="menuindex == 1 ? 'icon-guanbi' : 'icon-caidan'"
				@click="Showmenu">
			</div>

			<!-- 搜索 -->
			<div class="sjj_sou2" :class="souindex2 ? 'sou_show2' : ''">
				<div class="sjj_sou2_1 flex sjj_sou1 cur_pointer" v-if="souindex2">
					<el-input @change="send" class="sjj_souinput" v-model="sousuo" placeholder="Please enter keyword..."
						placeholder-class="tit-16" placeholder-style="color:#757575;"></el-input>
					<div class="iconfont icon-sousuo1 tit-26" style="color: #666666;" @click="send()"></div>
				</div>
			</div>
			<!-- 搜索 -->

		</div>

		<div class="resource-menu w100 a-center flex j-center bj-0 pt-27 pb-29">
			<div v-for="(t, i) in menulist" class="flex item cur_pointer" @click="Dian(t, i)">
				<div class="resource-menu-dian mr-7" :class="index == i || yixuanmenu == i ? 'active' : 'default'">
				</div>
				<div :class="index == i || yixuanmenu == i ? 'activezi' : 'ys-33'" class="tit-18 B-300 montserLight">{{
					t.name }}
				</div>
			</div>
		</div>




		<div class="sjj_nav" :class="menuindex ? 'nav_show' : ''">
			<div class="sjj_nav_box">
				<!-- <div class="sjj_nav_tu">
					<el-image
						src="https://goodwe.hnydl.com.cn/gongyong/shangchuan/tu/33/2024/11/l0EVPqVQ7V8I8eN7JVV0Mov7om2P57.png"
						class="sjj_nav_logo"></el-image>
				</div>
				<div class="sjj_nav_sousuo iconfont icon-sousuo1" @click="showsou"></div> -->
				<div>
					<el-menu v-for="(l, index) in list2">
						<el-submenu v-if="l.menulist && l.menulist.length > 0" :index="l.url">
							<template slot="title">
								<span @click="handleMenuClick(l.url)">{{ l.name }}</span>
							</template>

							<el-menu-item @click="handleMenuClick(l2.url)" :index="l2.url"
								v-for="l2 in l.menulist">{{ l2.name }}</el-menu-item>

						</el-submenu>
						<el-menu-item v-else :index="l.url" @click="handleMenuClick(l.url)">
							<span slot="title">{{ l.name }}</span>
						</el-menu-item>
					</el-menu>
				</div>
			</div>
		</div>
		<div class="sjj_sou" :class="souindex ? 'sou_show' : ''">
			<div class="sjj_sou1 flex" v-if="souindex">
				<el-input class="sjj_souinput" v-model="sousuo" placeholder="Please enter keyword..."
					placeholder-class="tit-16" placeholder-style="color:#757575;"></el-input>
				<div class="iconfont icon-sousuo1 tit-26" style="color: #666666;" @click="send()"></div>
			</div>
		</div>
		<el-dialog title="" class="fromtanbox" width="80%" top="20vh" :visible.sync="fromtan"  :append-to-body="true"
    :modal-append-to-body="true"
    :z-index="9999">
			<div class="fromtan_zi f24 mb-20">Dear Community Users，</div>
			<div class="fromtan_zi f24 mb-10">We would like to inform you that forum section of GoodWe Solar Community will be officially discontinued starting from 22th Apil 2026.</div>
			<div class="fromtan_zi f24 mb-10">This decision has been made as part of our ongoing efforts to streamline our services and enhance user experience. While the forum will no longer be available, please rest assured that all other website functions and services will continue to operate as normal without any impact.</div>
			<div class="fromtan_zi f24 mb-10">To better support your needs, we encourage you to make use of the SEMS+ AI Agent feature on SEMS+ APP. The AI Agent provides real-time assistance, helping you quickly find answers, troubleshoot issues, and access relevant information more efficiently.</div>
			<div class="fromtan_zi f24 mb-10">If you have any questions or require further assistance, please feel free to contact our support team: <a href="https://goodwetechnology.zendesk.com/hc/en-gb/requests/new. ">https://goodwetechnology.zendesk.com/hc/en-gb/requests/new. </a></div>
			<div class="fromtan_zi f24 mb-10">Thank you for your understanding and continued support.</div>
			<div class="fromtan_zi f24 mb-10">Best regards,</div>
			<div class="fromtan_zi f24 mb-10">GoodWe Solar Academy</div>
		</el-dialog>
	</div>
</template>

<script>
	function debounce(func, wait) {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => {
		func.apply(this, args);
		}, wait);
	};
	}

import loginVue from '../views/Gdewe/Login/login.vue'
import { allUser } from '@/api/user.js';
import {
	myxiangqing
} from '@/api/Personal.js';
export default {
	data() {
		return {
			fromtan:false,
			list: [{ name: 'Forum', url: '' }, { name: 'Resource', url: 'LearningLab' }, { name: 'GoodWe Plus+', url: 'plus' }, { name: 'Points Mall', url: 'pointsMall' }],
			// 移动端栏目
			list2: [{ name: 'Forum', url: '' },
			{
				name: 'Resource', url: 'Resource',
				// 
				menulist: [{ name: 'Video', url: 'video' }, { name: 'Blog', url: 'blog' }, { name: 'Webinar', url: 'webinar' }, { name: 'PV Sizing Tool', url: 'PVSizingTool' }],
			},
			{ name: 'GoodWe Plus+', url: 'plus' }, { name: 'Points Mall', url: 'pointsMall' }],



			// yuyanlist: [{ name: 'English', url: '' }, { name: 'Português-Brazil', url: '' }, { name: 'Türkçe', url: '' }],
			yuyanlist: [{
				name: 'English',
				url: '',
				k: 'EN'
			}, {
				name: 'Português-Brazil',
				url: '',
				k: 'PT'
			},
			{
				name: 'English-Pakistan',
				url: '',
				k: 'PK'
			}
			// , {
			// 	name: 'Türkçe',
			// 	url: '',
			// 	k: 'TN'
			// },
			],
			xianshi: 0,
			menuindex: 0,
			souindex: 0,
			bofanindex: 0,
			xianshi2: 0,
			index: -1,
			souindex2: 0,
			shipinindex: 0,//播放视频
			xianyu: 0,
			sousuo: '',
			gunshang: '',			
			gunshang2: '',
			leiming: '',
			bannerheight: "",
			mail: {},
			yixuanmenu: '',
			searchType: 1,
			index: -1,
			Tindexx: '',
			// , { name: 'Calculator', url: 'proComOne' }
			menulist: [{ name: 'Video', url: 'video' }, { name: 'Blog', url: 'blog' }, { name: 'Webinar', url: 'webinar' },{ name: 'PV Sizing Tool', url: 'PVSizingTool' }],
			shu: [{
				tu: 'https://goodwe.hnydl.com.cn/gongyong/shangchuan/tu/33/2024/11/rQAM9m111WceECcm1gq9CGCjG4QzJj.png'
			},
			{
				tu: 'https://goodwe.hnydl.com.cn/gongyong/shangchuan/tu/33/2024/11/rQAM9m111WceECcm1gq9CGCjG4QzJj.png'
			},
			{
				tu: 'https://goodwe.hnydl.com.cn/gongyong/shangchuan/tu/33/2024/11/rQAM9m111WceECcm1gq9CGCjG4QzJj.png'
			}
			],
			kouling: '',
			yuyancode:'EN',
			gudingziduan:{},
			plusRegion:''
		}
	},
	created() {
		this.yixuanmenu = Number(this.$qu('Menuindex'))
		this.Tindexx = Number(this.$qu('Tindex'))
		this.kouling = this.$qu('kouling')
		if(this.$qu('yuyancodes')!=[] && this.$qu('yuyancodes')!=''){
			this.yuyancode=this.$qu('yuyancodes')
			this.$store.commit('Gaiyuyan',this.$qu('yuyancodes'));
		}else{
			this.yuyancode=this.$store.state.yuyan
			this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		}
		this.gudingziduan=this.$store.state.cunyuanyan
		// console.log(this.gudingziduan)
		
		if (!this.$qu('kouling')) {
			allUser().then(s => {
				if (s.code > 200) {
					this.$cun('yonghuming', '')
					this.$cun('kouling', '')
					this.denglu = false
				}
			})
		}
		myxiangqing().then(res => {
			if(res.code==200){
				this.plusRegion=res.data.plusRegion
			}
			// console.log(res)
			// console.log(99999)
		})
	},
	mounted() {
		window.addEventListener('resize', this.handleResize); // 添加事件监听器 

		this.debouncedHandleScroll = debounce(this.handleScroll, 100);
		window.addEventListener('scroll', this.debouncedHandleScroll);
	},

	beforeDestroy() {
		window.removeEventListener('scroll', this.debouncedHandleScroll);
	},
	methods: {
		yuyandian(e) {
			this.yuyancode=e
			// console.log(e,'yuyandian')
			this.$cun('yuyancodes',this.yuyancode)
			this.$store.commit('Gaiyuyan', e);
			setTimeout(() => {
				// console.log(this.$store.state.cunyuanyan)
				this.gudingziduan=this.$store.state.cunyuanyan
			}, 600)
		},
		handleResize() {
			this.screenWidth = window.innerWidth; // 更新屏幕宽度  
			if (this.screenWidth <= 1100) {
				this.xianshi = 1
			}
		},
		handleMenuClick(url) {
			if(url==""){
				this.fromtan=true
			}else{
				this.$router.push({
					path: url
				}); // 跳转到 Vue Router 中定义的路由  
			}
		},

		handleScroll() {
			var that = this
			const scrollTop = window.scrollY; // 获取滚动位置  
			// console.log(scrollTop);
			
			// console.log(that.xianshi)
			if (scrollTop > 10) {
				that.gunshang = 'transform: translateY(-.6rem);'
			} else {
				that.gunshang = 'transform: translateY(0);'

			}
		},
		send() {
			// var searchType=0
			if (this.yixuanmenu == 0) {
				this.searchType = 4
			} else if (this.yixuanmenu == 1) {
				this.searchType = 3
			} else if (this.yixuanmenu == 2) {
				this.searchType = 2
			}
			this.$dakai('search?searchType=' + this.searchType + '&keyword=' + this.sousuo)
		},
		showsou() {
			this.souindex = !this.souindex
		},
		shousousuo() {
			this.souindex2 = !this.souindex2
		},
		Showmenu() {
			this.menuindex = !this.menuindex
			this.souindex = false
		},
		diankai() {
			this.xianshi2 = !this.xianshi2
		},
		showsou() {
			this.souindex = !this.souindex
		},
		xuanyan() {
			this.xianyu = !this.xianyu
		},
		bofan() {
			// this.bofanindex = !this.bofanindex
			window.open('https://en.goodwe.com')
		},
		Dian(e, i) {
			this.index = i
			// this.$router.push('/' + e.url)
			this.$router.push({name:e.url});
			if (i == 0) {
				this.$cun('Menuindex', '0')
			} else {
				this.$cun('Menuindex', i)
			}
		},
		tiaoz(e, i) {
			if (i == 0) {
				this.$cun('Tindex', '0')
			} else {
				this.$cun('Tindex', i)
			}
			this.$cun('Menuindex', -1)
			// this.$router.push('/' + e.url)
			if(e.url!=''){
				this.$router.push({name:e.url});
			}else{
				this.fromtan=true
			}
		},
		Shouye() {
			this.$router.push('/')
		}
	}
}
</script>

<style lang="scss" scoped>
.zihong {
	color: red !important;
}
.fromtan_zi{
	color:#333;
}
.Gheader_login_item {
	height: .54rem;
	line-height: .54rem;
	padding: 0 1.23rem 0 0;
	color: #333;
	box-sizing: border-box;
	// border-right: 1px solid #333;
	position: relative;
}

.Gheader2 {
	width: 100%;
	margin: 0 auto;
	border-bottom: 1px #f5f5f5 solid;
	position: sticky;
	top: 0;
	z-index: 999;
	transition: .5s;

	.iconfont {
		margin-right: 0.05rem;
	}

	.Gheader2_menu {
		position: relative;
		background: rgba(255, 255, 255, 0.8);
		width: 100%;
		height: .89rem;
		min-height: 70px;
		background: #fff;
		transition: all 0.5s;
		justify-content: space-between;

		div:hover {
			cursor: pointer;
		}

		.logo {
			display: flex;
			align-items: center;
			margin-left: 1.28rem;

			::v-deep .el-image__inner {
				width: 2.02rem;
				height: .48rem;
			}
		}

		.Gheader2_right_menu {
			width: 35%;
			justify-content: space-between;

			.item {
				font-weight: 400;
				text-align: center;
				color: #333333;
				display: flex;
				align-items: center;
				position: relative;
				span-decoration: none;
				color: black;
				transition: .5s;
			}

			.item:hover {
				color: red;
				cursor: pointer
			}
		}

		.Gheader2_right_soubox {
			// width: 19%;
			justify-content: space-between;

			.Gheader2_right_soubox_item {
				font-weight: 400;
				color: #333333;
				padding: 0 .27rem;
				display: flex;
				align-items: center;

				div {
					margin: 0 0.47rem 0 0;
				}
			}

			.Gheader2_right_soubox_item:first-child::after {
				content: "";
				width: 1px;
				height: .15rem;
				background: #c5c5c5;
				position: absolute;
				top: 50%;
				right: 0;
				transform: translateY(-50%);
			}

			.Gheader2_right_bofan {
				background: url('../assets/pc/logo/logo2.png') no-repeat;
				background-size: 100% 100%;
				width: 1.35rem;
				height: .44rem;
				border-radius: .22rem;
			}
		}

		.mini_right_menu {
			display: none;
		}
	}


	.resource-menu {
		border-top: 1px solid rgba(140, 140, 140, 0.1);

		.item {
			align-items: center;

			.resource-menu-dian {
				width: 8px;
				height: 8px;
				border-radius: 50%;
			}

			.default {
				background: #EEEEEE;
			}

			.active {
				background: #E70A16;
			}

			.activezi {
				color: #E70A16;
			}
		}

		.item:not(:last-child) {
			margin-right: .65rem;
		}
	}
}

.sjj_nav {
	position: fixed;
	z-index: 9;
	background: #fff;
	width: 100%;
	height: 0;
	line-height: 40px;
	right: 0;
	overflow: auto;
	overflow-x: hidden;
	transition: top ease 0.35s, height ease .4s;
	margin-bottom: 1rem;
	overflow-y: auto;
}

.nav_show {
	z-index: 9;
	height: 100vh;
}

.sjj_sou {
	position: fixed;
	z-index: 9999;
	width: 100%;
	height: 0px;
	// display: none;
	background: rgba(255, 255, 255, 0.7);
	border-radius: 20px;
	top: 108px;
	transition: height 0.1s ease;
	/* 添加过渡效果 */
	// transform: translateX(-50%);
	// border-top: 1px solid #dfdede;
	backdrop-filter: blur(20px);
	align-items: center;
}

.sjj_sou2 {
	position: absolute;
	z-index: 9;
	width: 100%;
	left: 0;
	height: 0px;
	// display: none;
	background: rgba(255, 255, 255, 0.7);
	border-radius: .2rem;
	top: 100%;
	transition: height 0.3s ease;
	/* 添加过渡效果 */
	// transform: translateX(-50%);
	// border-top: 1px solid #dfdede;
	backdrop-filter: blur(.2rem);
	align-items: center;

	.sjj_sou2_1 {
		margin-top: 0.31rem;
		transition: all 0.9s ease;
	}
}

.sou_show2 {
	height: 1.11rem;
	display: inherit;

	.sjj_sou2_1 {
		// display: inherit;
	}

}

.sjj_sou1 {
	// display: none;
	width: 50%;
	margin-left: 25%;
	box-sizing: border-box;
	border-bottom: 1px solid #dfdede;
	align-items: center;
	// margin-top:40px;
	// padding:15px 0;
	justify-content: space-between;

	.icon-sousuo1 {
		margin-right: 0.1rem !important;
	}
}

.sjj_nav_box {
	// margin: 0 10%;
	max-height: 100%;
	overflow-y: auto;

	.sjj_nav_item {
		border-bottom: 1px #ddd solid;
		position: relative;
		padding: .3rem 0;
		text-align: center;
		color: #666;

		&:last-child {
			border: 0;
		}
	}

	.el-menu {
		border-bottom: 1px solid #ddd;
		border-right: 0;

		.el-menu {
			border-bottom: 0;
		}

		&:last-child {
			border: 0;
		}
	}

	.el-menu-item:focus,
	.el-menu-item:hover {
		background: none;
	}

	.el-menu-item.is-active {
		color: #e70a16;
	}


	.el-submenu__title:hover {
		background: none;
	}
}

.sjj_souinput .el-input__inner {
	border: none !important;
	background: none !important;
}

// @media only screen and (max-width:1100px) {
// 	.Gheader2 {
// 		width: 100%;
// 		top: 0;
// 		left: 0;

// 		.Gheader2_login {
// 			width: 100%;
// 			background: #fff;
// 			position: fixed;
// 			top: 0;
// 			left: 0;
// 			z-index: 99;
// 			box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.15);

// 			div {
// 				color: #333;
// 			}
// 		}

// 		.Gheader2_menu {
// 			z-index: 9998;
// 			width: 100%;
// 			height: 55px;
// 			background: #fff;
// 			border-radius: inherit;
// 			box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.15);
// 			top: 0px;
// 			left: 0;
// 			z-index: 98;

// 			.logo {
// 				width: 18%;
// 				height: 40px;
// 				// margin-left: 47px;
// 				margin: 0.1rem 0.1rem 0.1rem 7%;
// 				transition: top 0.2s, height 0.5s, background 0.3s ease;
// 			}

// 			.guanbilogo {
// 				height: 0px;
// 			}

// 			.Gheader2_right_menu {
// 				display: none !important;
// 			}

// 			.Gheader2_right_soubox {
// 				display: none !important;
// 			}

// 			.mini_right_menu {
// 				display: inherit;
// 				height: 55px;
// 				line-height: 55px;
// 				margin-right: 5%;
// 				font-weight: 500;
// 				color: #000;
// 			}

// 		}

// 	}

// 	.sou_show {
// 		// top:108px;
// 		height: 110px;
// 		display: inherit;
// 	}

// 	// .sjj_sou1{
// 	// 	display: inherit;
// 	// }
// }

// 语言下拉样式修改
.el-dropdown-menu {
	padding: 10px 0;
	margin: 5px 0;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
	color: #fff;
	background: rgba(231, 10, 22, 1);
}


// ==========================================================================================================================================================================
// 响应式
@media only screen and (max-width:1024px) {
	.Gheader2 {
		width: 100%;
		top: 0;
		left: 0;

		.resource-menu {
			display: none;
		}

		.Gheader2_menu {
			position: relative;
			z-index: 9998;
			width: 100%;
			background: #fff;
			border-radius: inherit;
			left: 0;
			z-index: 98;
			box-shadow: none !important;
			border-bottom: 1px solid #eee;

			.Gheader2_right_menu {
				display: none !important;
			}

			.Gheader2_right_soubox {
				padding-right: 1.5rem;
			}

			.mini_right_menu {
				display: inherit;
				position: absolute;
				right: 0;
				margin-right: 5%;
				font-weight: 500;
				color: #000;
				font-size: var(--font24);
				top: 50%;
				transform: translateY(-50%);
			}
		}
	}

	.Gheader2 {
		position: sticky;
	}

	.Gheader2 .Gheader_login {
		position: sticky;
		width: 100%;
		background: #fff;
		left: 0;
		border-bottom: 1px solid #eee;
		min-height: 30px;
	}

	.Gheader2 .Gheader_login_item {
		color: #333;
	}

	.Gheader2 .Gheader_menu {
		position: sticky;
	}

	.sjj_sou {
		border-radius: 0;
	}

	.sjj_sou2 {
		border-radius: 0;
	}

	.sou_show {
		height: 110px;
		display: inherit;
	}

	.sou_show2 {
		border-radius: 0;
		display: block;
	}

	.sjj_sou2 .sjj_sou2_1 {
		margin-top: 0rem;
	}
}

@media screen and (max-width: 767px) {
	.Gheader2 {
		position: sticky;
	}

	.Gheader2 .Gheader_login_item {padding: 0 .23rem;}


	.Gheader2 .Gheader2_menu {
		min-height: 60px;
		position: sticky;
	}

	.Gheader2 .Gheader2_menu .logo {
		margin-left: .4rem;
	}

	.Gheader2 .Gheader2_menu .Gheader2_right_soubox {
		padding-right: .7rem;
	}

	.Gheader2 .Gheader2_menu .mini_right_menu {
		font-size: var(--font30);
	}

	.Gheader2 .Gheader2_menu .Gheader2_right_soubox .Gheader2_right_soubox_item {
		padding: 0;
		padding-right: .3rem;
	}

	.Gheader2 .Gheader2_menu .Gheader2_right_soubox .Gheader2_right_soubox_item div {
		margin: 0;
	}

	.Gheader2 .Gheader2_menu .Gheader2_right_soubox .Gheader2_right_soubox_item.xiant2 {
		padding-left: .3rem;
	}

	.sjj_sou1 {
		width: 90%;
		margin: 0 5%;
	}
}
</style>